var $d4c3aec691729ee8$exports = {};
$d4c3aec691729ee8$exports = {
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};


export {$d4c3aec691729ee8$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
